module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "d-flex pb-3 mb-3 border-bottom-light justify-content-between align-items-center pointer",
    on: {
      "click": _vm.toggleExpand
    }
  }, [_c('span', {
    staticClass: "font-weight-600"
  }, [_vm._v("RESOURCES")]), _vm._v(" "), _c('i', {
    staticClass: "ico mx-0 fs-normal",
    class: {
      'ico-arrow-top': _vm.group.resourcesExpanded,
      'ico-arrow-bottom': !_vm.group.resourcesExpanded
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "resources-manager__panel-holder",
    class: {
      closed: !_vm.group.resourcesExpanded
    }
  }, [(_vm.form.availabilityType == 2) ? _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "mt-2 mb-3 fs-small dark"
  }, [_c('div', {
    staticClass: "mt-2 mb-3 flex-shrink-0 fs-small dark"
  }, [(_vm.form.productShareType !== 2) ? _c('div', {
    staticClass: "d-flex"
  }, [_c('radio', {
    staticClass: "d-inline",
    attrs: {
      "value": 0,
      "disabled": _vm.disabled || _vm.form.isPrivate == true || _vm.form.productShareType == 2,
      "checked": _vm.form.isPrivate == true
    },
    model: {
      value: (_vm.group.shareType),
      callback: function($$v) {
        _vm.$set(_vm.group, "shareType", $$v)
      },
      expression: "group.shareType"
    }
  }, [_c('span', {
    staticClass: "resources-manager__share-type--limited-width ml-2"
  }, [_vm._v("NO")])])], 1) : _vm._e(), _vm._v(" "), (_vm.form.productShareType !== 2) ? _c('div', {
    staticClass: "d-flex mt-2"
  }, [_c('radio', {
    staticClass: "d-inline",
    attrs: {
      "value": 1,
      "disabled": _vm.disabled || _vm.form.isPrivate == true || _vm.form.productShareType == 2
    },
    model: {
      value: (_vm.group.shareType),
      callback: function($$v) {
        _vm.$set(_vm.group, "shareType", $$v)
      },
      expression: "group.shareType"
    }
  }, [_c('span', {
    staticClass: "resources-manager__share-type--limited-width ml-2"
  }, [_vm._v("YES. Products that use the same resource at the same time will share availability. You can set max.seats per product.")])])], 1) : _vm._e(), _vm._v(" "), (_vm.form.productShareType == 2) ? _c('div', [_vm._v("\n                        To change this property you need to disable Virtual Roster\n                    ")]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.availableResources == undefined) ? _c('div', {
    staticClass: "text-center dark"
  }, [_c('div', [_vm._v("Loading resources please wait")])]) : [(_vm.availableResources && _vm.availableResources !== undefined && _vm.availableResources.length > 0) ? _c('div', {}, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('table', {
    staticClass: "table narrow"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "pl-3",
    staticStyle: {
      "width": "70%"
    }
  }, [_vm._v("Resource")]), _vm._v(" "), (_vm.form.shareType == 2) ? _c('th', {
    staticClass: "pl-3",
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("Max. Seats")]) : _c('th', {
    staticClass: "pl-3",
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("Max. Seats")]), _vm._v(" "), _c('th', {
    staticClass: "pl-3",
    staticStyle: {
      "width": "50px"
    }
  }, [_vm._v(" ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.group.resources), function(resource, index) {
    return _c('tr', {
      key: resource.id + '-' + index,
      class: {
        'notAllowed': _vm.disabled
      }
    }, [_c('td', {
      staticClass: "p-3"
    }, [(!_vm.getLoadingResources) ? _c('v-select', {
      class: {
        'notAllowed': _vm.disabled
      },
      attrs: {
        "options": _vm.resourcesToSelect,
        "placeholder": "- Select resource -",
        "label": "name",
        "disabled": _vm.disabled
      },
      on: {
        "input": _vm.updateResourcesList
      },
      model: {
        value: (_vm.group.resources[index]),
        callback: function($$v) {
          _vm.$set(_vm.group.resources, index, $$v)
        },
        expression: "group.resources[index]"
      }
    }) : _c('div', [_vm._v("\n                                            Loading\n                                        ")])], 1), _vm._v(" "), (_vm.form.availabilityType == 2) ? _c('td', {
      staticClass: "pl-3"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (resource.maxSeats),
        expression: "resource.maxSeats",
        modifiers: {
          "number": true
        }
      }, {
        name: "numInt",
        rawName: "v-numInt"
      }],
      staticClass: "mr-2",
      class: {
        'border-color-6': resource.invalid
      },
      staticStyle: {
        "width": "55px"
      },
      attrs: {
        "type": "text",
        "disabled": _vm.disabled,
        "max": _vm.fetchCapacity(resource)
      },
      domProps: {
        "value": (resource.maxSeats)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(resource, "maxSeats", _vm._n($event.target.value))
        }, function($event) {
          return _vm.maxSeatsChanged(resource)
        }],
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    }), _vm._v(" /\n                                        "), _c('span', [_vm._v(_vm._s(_vm.fetchCapacity(resource)))]), _vm._v(" "), (resource.invalid) ? _c('span', {
      staticClass: "color-6 ml-2 fs-smaller"
    }, [_vm._v("Invalid")]) : _vm._e()]) : _c('td', {
      staticClass: "pl-3"
    }, [_vm._v("\n                                        " + _vm._s(_vm.fetchCapacity(resource)) + "\n                                    ")]), _vm._v(" "), _c('td', [_c('i', {
      staticClass: "ico-delete largest medium",
      class: {
        'pointer': !_vm.disabled,
        'notAllowed': _vm.disabled
      },
      on: {
        "click": function($event) {
          return _vm.deleteRow(index, 'resources')
        }
      }
    })])])
  }), 0)]), _vm._v(" "), (_vm.resourcesToSelect.length == 0 && _vm.availableResources.length > 0) ? _c('span', {
    staticClass: "fs-small dark bold ml-2"
  }, [_vm._v("All resources used")]) : _vm._e(), _vm._v(" "), (!_vm.readOnly) ? _c('div', {
    staticClass: "add d-flex align-items-center fs-small bold mt-4 mb-3",
    class: {
      'pointer': !_vm.disabled,
      'notAllowed': _vm.disabled || _vm.resourcesToSelect.length == 0,
      'opacity-50': _vm.resourcesToSelect.length == 0
    },
    on: {
      "click": _vm.addResource
    }
  }, [_c('i', {
    staticClass: "ico-add fs-smallest add-circle color-1"
  }), _vm._v(" Add resource\n                        ")]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.availableResources && _vm.availableResources.length == 0) ? _c('div', {
    staticClass: "text-center dark"
  }, [_c('div', [_vm._v("⛵  You have no resources, let's add one to your inventory.")]), _vm._v(" "), _c('button', {
    staticClass: "btn mt-3",
    attrs: {
      "type": "button",
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.createResource
    }
  }, [_vm._v("Create Resources")])]) : _vm._e()]], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex align-items-start"
  }, [_c('span', [_vm._v("Use these resources for other activities at the same time?")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0672c702"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inventory/products/components/ResourcesManager.vue
// module id = 1504
// module chunks = 0